import { render, staticRenderFns } from "./CreateCourier.vue?vue&type=template&id=2c67a9c3&scoped=true&"
import script from "./CreateCourier.vue?vue&type=script&lang=js&"
export * from "./CreateCourier.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourier.vue?vue&type=style&index=0&id=2c67a9c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67a9c3",
  null
  
)

export default component.exports